import React from 'react'

import Menu from './Menu'
import MenuItem from './MenuItem'

 











const SlackChannelDropdown = (props) => {
  const {defaultActiveIdx, channels, menuProps, onClick} = props
  return (
    React.createElement(Menu, {
      ariaLabel: 'Select the channel to send notifications to',
      ...menuProps,
      defaultActiveIdx: defaultActiveIdx,}

      , channels.map((channel) => {
        return React.createElement(MenuItem, { key: channel.id, label: channel.name, onClick: onClick(channel.id),} )
      })
    )
  )
}

export default SlackChannelDropdown
